<app-template-map [disabled]="disabled" [value]="value" [mode]="mode" [control]="control" [options]="options" [polygon]="true" [label]="label" />
